
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import axios from 'axios';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from "@mui/material";
import { useStripe } from '@stripe/react-stripe-js';

import Footer from "../Footer";
import Header from "../Header";
import { getAuthToken } from "../../utils/auth";
import Loader from "../OtherComponents/Loader";
let Base_Url = process.env.REACT_APP_BASE_URL;

const Payment = () => {
    const location = useLocation();
    const userData = location?.state?.userData;
    const postData = location?.state?.postData;
    const stripe = useStripe();
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        cardNumber: "",
        cvv: "",
        expirationDate: null,
        name: "",
        phoneNumber: "",
        amount: "",
        email: ""
    });
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const validate = () => {
        let errors = {};
        if (!formValues.amount) {
            errors.amount = "Amount is required";
        } else {
            if (postData.paidAmount) {
                let amountValue = parseFloat(postData.amount) - parseFloat(postData.paidAmount)
                if (parseFloat(formValues.amount) > amountValue) {
                    errors.amount = `Amount must not exceed ${amountValue}`;
                }
            }
            else {
                if (parseFloat(formValues.amount) > parseFloat(postData.amount)) {
                    errors.amount = `Amount must not exceed $${postData.amount} canadian dollars`;
                }
            }
        }
        if (!formValues.cardNumber) errors.cardNumber = "Card number is required";
        if (!formValues.cvv) errors.cvv = "CVV is required";
        if (!formValues.expirationDate) errors.expirationDate = "Expiration date is required";
        if (!formValues.name) errors.name = "Name is required";
        if (!formValues.phoneNumber) errors.phoneNumber = "Phone number is required";
        if (!formValues.email) errors.email = "Email is required";
        if (formValues.cardNumber.replace(/-/g, '').length !== 15 && formValues.cardNumber.replace(/-/g, '').length !== 16) {
            errors.cardNumber = `Card number must be 15 digits for American Express or 16 for others`;
        }
        return errors;
    };

    const formatCardNumber = (value) => {
        const cleaned = value.replace(/\D+/g, '');
        let formatted = '';
        for (let i = 0; i < cleaned.length; i++) {
            if (i > 0 && i % 4 === 0) {
                formatted += '-';
            }
            formatted += cleaned[i];
        }
        return formatted;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormErrors({ ...formErrors, [name]: '' });
        if (name === 'cardNumber') {
            const formattedValue = formatCardNumber(value);
            setFormValues({ ...formValues, [name]: formattedValue });
        } else {
            setFormValues({ ...formValues, [name]: value });
        }
        if (name === 'cvv' && value.length !== 3) {
            setFormErrors({ ...formErrors, cvv: 'CVV length must be 3 digits' });
        }
    };

    const handleDateChange = (date) => {
        setFormErrors({ ...formErrors, expirationDate: '' });
        setFormValues({ ...formValues, expirationDate: date });
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1;
        let expMonth = date.$M + 1;
        let expYear = date.$y;
        if (expYear < currentYear || (expYear === currentYear && expMonth < currentMonth)) {
            setFormErrors({ ...formErrors, expirationDate: 'Enter a valid expiration date' });
        }
    };

    const handleSubmit = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setFormErrors(validationErrors);
        } else {
            setFormErrors({});
            try {
                setLoading(true);
                const token = getAuthToken();
                if (token) {
                    const modifiedFormValues = { ...formValues, post_id: postData._id, user_id: userData, description: postData.title };
                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    const apiresponse = await axios.post(`${Base_Url}/api/stripe`, modifiedFormValues);
                    await stripe.confirmCardPayment(
                        apiresponse.data.client_secret
                    );
                    await axios.post(`${Base_Url}/api/posts/update`, modifiedFormValues);
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000)
                    setTimeout(() => {
                        navigate('/thankYou', { state: { paymentSuccess: true } })
                    }, 1000)
                }
            } catch (err) {
                // console.log(err.response.data)
                setFormErrors({ server: "Failed Payment. Please try again." });
                toast.error(err.response.data.msg)
                setLoading(false);
            }
        }
    };

    return (
        <>
            <Header />
            <ToastContainer />
            {loading ? <Loader />
                :
                <section className="billing-dontaion-main">
                    <div className="container">
                        <div className="billng-form-flex">
                            <div className="payment-form-left">
                                <h2 className="payment-title"><span className="biling-color">Billing</span> Information</h2>
                                <div className="payment-form">
                                    <div className="form-section">
                                        <div className="left-pay-cl">
                                            <div className="payment-type-flex">
                                                <div className="flex-contact">
                                                    <label htmlFor="card-number">Credit Card Number *</label>
                                                    <input
                                                        type="text"
                                                        id="card-number"
                                                        name="cardNumber"
                                                        placeholder="XXXX-XXXX-XXX-XXX"
                                                        value={formValues.cardNumber}
                                                        onChange={handleChange}
                                                        required />
                                                    {formErrors.cardNumber && <p className="errors">{formErrors.cardNumber}</p>}
                                                </div>
                                            </div>
                                            <div className="payment-type-flex">
                                                <div className="flex-contact">
                                                    <label htmlFor="cvv">Card Verification (CVV) *</label>
                                                    <input
                                                        type="text"
                                                        id="cvv"
                                                        name="cvv"
                                                        placeholder="XXX"
                                                        value={formValues.cvv}
                                                        onChange={handleChange}
                                                        required />
                                                    {formErrors.cvv && <p className="errors">{formErrors.cvv}</p>}
                                                </div>
                                                <div className="flex-contact">
                                                    <label htmlFor="expiration-date">Expiration Date *</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            id="expiration-date"
                                                            views={['month', 'year']}
                                                            value={formValues.expirationDate}
                                                            onChange={handleDateChange}
                                                            renderInput={(params) => <TextField {...params} required />}
                                                            format="MM/YYYY"
                                                        />
                                                    </LocalizationProvider>
                                                    {formErrors.expirationDate && <p className="errors">{formErrors.expirationDate}</p>}
                                                </div>
                                            </div>

                                            <div className="payment-type-flex">
                                                <div className="flex-contact">
                                                    <label htmlFor="name">Name *</label>
                                                    <input
                                                        type="text"
                                                        id="name"
                                                        name="name"
                                                        value={formValues.name}
                                                        onChange={handleChange}
                                                        required />
                                                    {formErrors.name && <p className="errors">{formErrors.name}</p>}
                                                </div>
                                                <div className="flex-contact">
                                                    <label htmlFor="email">Email *</label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        value={formValues.email}
                                                        onChange={handleChange}
                                                        required />
                                                    {formErrors.email && <p className="errors">{formErrors.email}</p>}
                                                </div>
                                            </div>

                                            <div className="payment-type-flex">
                                                <div className="flex-contact">
                                                    <label htmlFor="phoneNumber">Phone Number *</label>
                                                    <input
                                                        type="tel"
                                                        id="phoneNumber"
                                                        name="phoneNumber"
                                                        value={formValues.phoneNumber}
                                                        onChange={handleChange}
                                                        required />
                                                    {formErrors.phoneNumber && <p className="errors">{formErrors.phoneNumber}</p>}
                                                </div>

                                                <div className="flex-contact">
                                                    <label htmlFor="amount">Amount *</label>
                                                    <input
                                                        type="text"
                                                        id="amount"
                                                        name="amount"
                                                        value={formValues.amount}
                                                        onChange={handleChange}
                                                        required />
                                                    <p style={{ marginBottom: '5px', marginTop: '-20px' }}><span className='text-danger'>Note* : Please enter amount in canadian dollars</span></p>

                                                    {formErrors.amount && <p className="errors">{formErrors.amount}</p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {formErrors.server && <p className="errors" style={{ paddingLeft: "20px" }}>{formErrors.server}</p>}
                                <div className="donate-btn-form">
                                    <button type="button" onClick={handleSubmit}>
                                        {!loading && 'Donate'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            }
            <Footer />
        </>
    );
};

export default Payment;
